import moment from 'moment'

export const sortByPositionHint = array => {
  const sorted = [...array]
  sorted.sort((a, b) => {
    return a.position > b.position ? 1 : -1
  })
  return sorted
}

export const sortByStartDate = array => {
  const sorted = [...array]

  sorted.sort((a, b) => {
    const lhs = moment(a.start)
    const rhs = moment(b.start)

    let ret = 0
    if (lhs.isValid() && rhs.isValid()) {
      ret = lhs.isAfter(rhs) ? 1 : -1
    } else if (lhs.isValid()) {
      ret = lhs.isValid() ? -1 : 1
    }

    return ret
  })
  return sorted
}

export const sortByDeletedDate = array => {
  const sorted = [...array]

  sorted.sort((a, b) => {
    const lhs = moment(a.deleted)
    const rhs = moment(b.deleted)

    let ret = 0
    if (lhs.isValid() && rhs.isValid()) {
      ret = lhs.isAfter(rhs) ? 1 : -1
    } else if (lhs.isValid()) {
      ret = lhs.isValid() ? -1 : 1
    }

    return ret
  })
  return sorted
}

export const sortByName = (array, decrypt) => {
  const sorted = [...array]
  sorted.sort((a, b) => {
    return decrypt(a.name) > decrypt(b.name) ? 1 : -1
  })
  return sorted
}
